/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class SetFocusService {
  public focusUpdated$: Observable<boolean>;
  public inputUpdated$: Observable<boolean>;

  private focusSource: Subject<boolean>;
  private inputSource: Subject<boolean>;

  constructor() {
    this.focusSource = new Subject();
    this.focusUpdated$ = this.focusSource.asObservable();

    this.inputSource = new Subject();
    this.inputUpdated$ = this.inputSource.asObservable();
  }

  public announceFocusUpdate(isSet: boolean): void {
    this.focusSource.next(isSet);
  }

  public announceInputClear(chosen: boolean): void {
    this.inputSource.next(chosen);
  }
}
